import { ChangeDetectionStrategy, Component, effect, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ModalLayoutComponent} from '../modal-layout/modal-layout.component';
import{ ButtonComponent } from '../../button/button.component';

@Component({
  selector: 'lib-temp-modal',
  imports: [CommonModule, ModalLayoutComponent, ButtonComponent],
  templateUrl: './temp-modal.component.html',
  styleUrl: './temp-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TempModalComponent {
  title = 'Modal Title';
  subtitle = 'modal subtitle';
  submit = signal(false);

  onSubmit() {
  }
}
